import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useEffectOnce } from '@chilecompra/react-kit'
import { Button, Skeleton, Toast } from '@chilecompra/react-kit/components'
import Header from './PartnershipCertificateDialog.header'
import SellerInformation from './PartnershipCertificateDialog.sellerInformation'
import Information from './PartnershipCertificateDialog.information'
import SellerAndPartner from './PartnershipCertificateDialog.sellerAndPartner'
import { onGetDatesAwardedThunk } from './PartnershipCertificateDialog.actions'
import { Root, Section, Strong } from './PartnershipCertificateDialog.styles'
import ImportantInformation from './PartnershipCertificateDialog.importantInformation'

/**
 * The PartnershipCertificateDialog' container.
 */
const PartnershipCertificateDialog = () => {
  const dispatch = useDispatch()
  const { certificate, error, loading, oldCertificate } = useSelector(state => state.partnershipCertificateDialog)
  const urlParams = useParams()
  const handleClickClose = () => window.close()

  useEffectOnce(() => {
    dispatch(onGetDatesAwardedThunk(urlParams))
  })

  return (
    <Root>
      <Header idSTU={certificate?.idSTU} isSTU={certificate?.isSTU} onClickClose={handleClickClose} />
      {error && !loading && (
        <Toast severity="warning" title="Información solicitada no disponible" width="100%">
          <Strong>Lo sentimos, en este momento estamos generando, o no contamos, con la información solicitada</Strong>
          <br />
          Por favor, consulta en unos minutos más.
        </Toast>
      )}
      {loading && <Skeleton height="200px" margin="0 0 20px" variant="rect" width="100%" />}
      <SellerInformation
        businessName={certificate?.businessName}
        datesAccepted={certificate?.dates?.accepted}
        dni={certificate?.dni}
        error={error}
        isSTU={certificate.isSTU}
        loading={loading}
        mechanismName={certificate?.mechanismName}
        purchaseOrderID={certificate?.purchaseOrderID}
      />
      {loading && <Skeleton height="16px" margin="0 0 12px" variant="rect" width="80%" />}
      <Information error={error} isSTU={certificate.isSTU} loading={loading} oldCertificate={oldCertificate} />
      {loading && (
        <Section margin="0 0 32px">
          <Skeleton height="35px" margin="0 0 0.4rem" variant="rect" width="100%" />
          <Skeleton height="30px" margin="0 0 0.2rem" variant="rect" width="100%" />
          <Skeleton height="30px" margin="0 0 0.2rem" variant="rect" width="100%" />
          <Skeleton height="30px" margin="0 0 0.2rem" variant="rect" width="100%" />
          <Skeleton height="30px" margin="0 0 0.2rem" variant="rect" width="100%" />
          <Skeleton height="30px" margin="0 0 0.2rem" variant="rect" width="100%" />
        </Section>
      )}
      {certificate &&
        !error &&
        !loading &&
        certificate?.sellers.map(seller => (
          <SellerAndPartner
            businessName={seller.businessName}
            dni={seller.dni}
            error={error}
            hasAgreement={certificate.hasAgreement}
            key={seller.dni}
            loading={loading}
            oldCertificate={oldCertificate}
            partnerships={seller.partnerships}
            source={certificate.source}
          />
        ))}
      {loading && <Skeleton height="16px" margin="0 0 48px" variant="rect" width="80%" />}
      {loading && <Skeleton height="36px" variant="rect" width="80%" />}
      <ImportantInformation
        completed={certificate.completed}
        datesGenerated={certificate?.dates?.generated}
        error={error}
        failed={certificate.failed}
        loading={loading}
        mechanismType={certificate.mechanismType}
      />
      <Section align="center" display="flex" margin="40px 0 0">
        <Button color="default" width="200px" onClick={handleClickClose}>
          Cerrar
        </Button>
      </Section>
    </Root>
  )
}

export default PartnershipCertificateDialog
